<template>
  <v-container class="container-card">
    <v-card>
      <TabelaFuncaoNivel />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaFuncaoNivel",

  components: {
    TabelaFuncaoNivel: () =>
      import("@/components/colaborador/funcaoNivel/TabelaFuncaoNivel")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Função Nível");
  }
};
</script>
